module.exports = __webpack_public_path__ + "img/export.00df770f.svg";